
import { mixins, Options } from 'vue-class-component'
import BaseFormDialogMixin from '@/components/common/mixins/BaseFormDialogMixin.vue'
import { Prop } from 'vue-property-decorator'
import { maska } from 'maska'
import { IRichMenu, IRichMenuContent } from '@/utils/types'
import CLoading from '@/components/common/ui/CLoading.vue'
import cloneDeep from 'lodash/cloneDeep'
import { ACTION_RICH_MENU } from '@/store/actions'
import { constant } from '@/utils/constants'

@Options({
  components: { CLoading },
  directives: { maska },
  emits: ['update:modelValue', 'update:submitMenu', 'update:refetchMenu'],
})
export default class CopyMenuModal extends mixins(BaseFormDialogMixin) {
  @Prop()
  menuData!: IRichMenuContent

  @Prop()
  isDraft!: boolean

  @Prop()
  loading!: boolean

  step = 1
  search = ''
  selectedMenu: IRichMenu = {}

  get modalTitle() {
    if (this.isDraft) {
      return '編集中の内容の保存'
    } else {
      if (this.step === 1) {
        return '複製先の選択'
      }
      return '複製完了'
    }
  }

  get destinationMenuName() {
    if (!this.isDraft && this.step === 2) {
      return this.selectedMenu.name || ''
    } else {
      return '店舗用'
    }
  }

  get richMenus() {
    return cloneDeep(this.$store.getters.richMenus) || []
  }

  get richMenusFilter() {
    if (this.search) {
      return this.richMenus.filter((item) => item.name.toLowerCase().includes(this.search.toLowerCase()))
    }
    return this.richMenus
  }

  get selectedAppId() {
    return this.$route.params.app_id
  }

  onSelectMenu(menu: IRichMenu) {
    this.selectedMenu = menu
  }

  onSubmit() {
    if (this.isDraft) {
      this.$emit('update:submitMenu')
    } else {
      if (this.step === 1) {
        this.step = 2
      } else {
        this.goto('rich_menu_setting', {
          app_id: this.selectedAppId,
          rich_menu_id: this.selectedMenu._id,
          action_type: constant.ACTION_TYPE.EDIT,
        })
        this.$emit('update:refetchMenu', this.menuData)
        this.visible = false
      }
    }
  }

  goto(name: string, params = {}) {
    this.$router.push({
      name,
      params,
    })
  }

  async mounted() {
    await this.$store.dispatch(ACTION_RICH_MENU.LOAD_ITEMS, {
      app_id: this.selectedAppId,
    })
  }
}
